import { AppIcon } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { useNotice } from '@backrs_ui/grow-ui/src/components/InstitutionWrite/NoticeHost';

import { Box, IconButton, type SxProps, type Theme, Typography } from '@mui/material';

const { copy: strings } = appStrings.modules.rostersAdmin;

type CopyableCodeProps = Readonly<{
  id: string;
  value: string;
}>;

export const CopyableCode = ({ id, value }: CopyableCodeProps) => {
  const { announce } = useNotice();

  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      announce(strings.copied);
    } catch (error) {
      console.error('Could not copy a join code', error);
      announce(strings.failed, 'error');
    }
  };

  return (
    <Box id={id} sx={rootSx}>
      <Typography variant="text-sm-medium" sx={codeSx}>
        {value}
      </Typography>
      <IconButton
        id={`${id}-copy`}
        className="copy-icon"
        size="small"
        aria-label={strings.aria(value)}
        onClick={() => void onCopy()}
      >
        <AppIcon iconName="Copy01" diameter="16px" color="Colors/Foreground/fg-secondary" />
      </IconButton>
    </Box>
  );
};

const codeSx: SxProps<Theme> = {
  letterSpacing: '0.08em',
};

const rootSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: backrs.spacing['spacing-xs'],
  '& .copy-icon': { opacity: 0, transition: 'opacity 0.15s' },
  '&:hover .copy-icon, & .copy-icon:focus-visible': { opacity: 1 },
});
